import { useState, useEffect, useMemo } from "react";
import { Skills } from "./Skills";

export interface UseGameDataResult {
    gameData: GameData;
    gameLookup: Record<string, GameDataItem>;
}

export const useGameData = (): UseGameDataResult => {
    const [, setResponseOk] = useState<boolean>();
    const [response, setResponse] = useState<string>();

    useEffect(() => {
        void (async () => {
            const response = await fetch("/play-tracker/game-data.json?v=2", { headers: { Accept: 'application/json' } });
            setResponseOk(response.ok);
            if (response.body) {
                setResponse(JSON.stringify(JSON.parse(await response.text()), null, 2));
            } else {
                setResponse(undefined);
            }
        })()
    }, [setResponse, setResponseOk]);

    const gameData: GameData = useMemo(() => {
        return response ? JSON.parse(response) : { games: [] };
    }, [response]);

    const gameLookup: Record<string, GameDataItem> = useMemo(() => gameData?.games.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
    }, {} as Record<string, GameDataItem>) ?? {}, [gameData?.games]);

    return useMemo(() => ({
        gameData,
        gameLookup,
    }), [gameData, gameLookup]);
}

export interface GameData {
    games: readonly GameDataItem[];
}

export interface GameDataItem {
    id: string;
    name: string;
    xp: Skills;
}
